import { Storage } from '@ionic/storage';
import { Component, OnInit } from '@angular/core';
import { FormGroup,FormControl,FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LoaderService } from '../loder_service/loader.service';
import { DataService } from '../data.service';
import { ActionSheetController } from '@ionic/angular';
import { Camera, CameraOptions } from '@ionic-native/camera/ngx';

import { AlertController } from '@ionic/angular';
@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
})
export class RegisterComponent implements OnInit {
  register:FormGroup;
  kyc_img:any;
  otp:any;
  constructor(public storage:Storage, public alertController:AlertController,public camera: Camera,public actionSheetController:ActionSheetController, public restApi:DataService,public toastService:LoaderService,public router:Router,public fb:FormBuilder) { 
   //this.kyc_img='hi'
    this.register = new FormGroup({
      // "user_name"      :  ["", Validators.required],
      // "address"      :  ["", Validators.required],
      // "pincode"      :  ["", Validators.required],
      // "mobile_no"      :  ["", Validators.required],
      // "password"      :  ["", Validators.required],
      // "email"      :  ["", Validators.required],
      // "referral_code"      :  [""],

      user_name: new FormControl('', [Validators.required]),
      address: new FormControl('', [Validators.required]),
      pincode: new FormControl('', [Validators.required]),
      mobile_no: new FormControl('', [Validators.required,Validators.pattern('^((\\+91-?)|0)?[0-9]{10}$')]),
      password: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.required]),
      referral_code: new FormControl('',[Validators.required]),

      
     
   });
  }
  _keyPress(event: any) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
        event.preventDefault();

    }
}
  ngOnInit() {}
doRegister(){
 

  
  this.toastService.showLoader('');

    let value=this.register.value
    let postparams={
      address:value.address,
      phone_no:value.mobile_no,
      pincode:value.pincode,
      user_name:value.user_name,
      email:value.email,
      password:value.password,
      cart_session:localStorage.getItem('cart_session'),
      referral_code:value.referral_code
    }
    console.log(postparams)
    this.restApi.user_register(postparams).subscribe((data:any)=>{
      if(data.result=="number_exist"){
          this.toastService.create('Mobile number already exists!')
          this.toastService.hideLoader();
      }else if(data.result=="email_exist"){
        this.toastService.create('Email  already exists!')
        this.toastService.hideLoader();
      }else if(data.result=="pan_card_exist"){
        this.toastService.create('Pan car number already exists!')
        this.toastService.hideLoader();
      }else if(data.result=="gst_no_exist"){
        this.toastService.create('Gst number already exists!')
        this.toastService.hideLoader();
      }else{
        this.toastService.create('You have successfully registered')
        this.toastService.hideLoader();
        this.router.navigate(['/signin'])
      }
    },(error:any)=>{
      this.toastService.hideLoader();
    })
 

}
another_function(){
  alert('hi')
}

gotosignin()
{
  this.router.navigate(['/signin'])
}
async presentActionSheet() {
  const actionSheet = await this.actionSheetController.create({
    header: 'Albums',
    cssClass: 'my-custom-class',
    buttons: [{
      text: 'Gallery',
      icon: 'images',
      handler: () => {
        console.log('Delete clicked');
        this.takePicture(this.camera.PictureSourceType.PHOTOLIBRARY);
      }
    }, {
      text: 'Camera',
      icon: 'camera',
      handler: () => {
        console.log('Share clicked');
        this.takePicture(this.camera.PictureSourceType.PHOTOLIBRARY);
      }
    }]
  });
  await actionSheet.present();
}


otp_verify(){
  this.toastService.showLoader('');
  if(this.register.valid){
    this.otp = Math.floor(1000 + Math.random() * 9000);
    let value=this.register.value
  
    let postparams={
      // mobile_no
      otp:this.otp,
      mobile_number:value.mobile_no,
      email:value.email,
      referral_code:value.referral_code
  
    }
    console.log(postparams)
    this.restApi.otp_verify(postparams).subscribe((data:any)=>{
      if(data.result==1){
        this.toastService.create('We have sent an otp to your mobile number message')
        // this.presentAlertPrompt()
        this.doRegister()
        this.toastService.hideLoader()
      }
      else if(data.result==3){

        this.toastService.create('Invalid referral code!')
       
        this.toastService.hideLoader()

      }
    },(error:any)=>{
      this.toastService.hideLoader()
      this.toastService.create('Having some isssues from server end')
    })
  }else{
    this.toastService.create('Please fill in the required fields')
    this.toastService.hideLoader()
  }
 
}

async presentAlertPrompt() {
  const alert = await this.alertController.create({
    header: 'OTP Verification!',
    inputs: [
      {
        name: 'otp',
        type: 'text',
        placeholder: 'Enter 4 digit OTP'
      },
    ],
    buttons: [
      {
        text: 'Cancel',
        role: 'cancel',
        cssClass: 'secondary',
        handler: () => {
          console.log('Confirm Cancel');
          //this.storage.remove('mobile_number');
        }
      }, {
        text: 'Ok',
        handler: data  => {
          console.log('Confirm Ok');
          console.log(data.otp)
          if(this.otp==data.otp){
            console.log('match')
            this.toastService.create('Your number is verified');
            this.doRegister()
            //this.number_verified='verified';
            //this.storage.set('mobile_number', this.number_verified);
            //this.isVerify=false;
          }else{
            console.log('noth match')
          }
        }
      }
    ]
  });

  await alert.present();
}





















public takePicture(sourceType) {
// Create options for the Camera Dialog
const options: CameraOptions = {
  quality: 100,
  sourceType: sourceType,
  saveToPhotoAlbum: false,
  correctOrientation: true
};

this.camera.getPicture(options).then((imageData) => {
 // imageData is either a base64 encoded string or a file URI
 // If it's base64 (DATA_URL):
 this.kyc_img= 'data:image/jpeg;base64,' + imageData;
 console.log(this.kyc_img)
 //this.toastService.showLoader('');

  // this.restApi.update_profile_image(postparams).subscribe((data:any)=>{
  //   this.toastService.hideLoader()
  //   this.toastService.create('Your profile updated successfully')
  // },(error:any)=>{
  //   this.toastService.hideLoader()
  //   this.toastService.create('Having some issues from server end');
  // })//api
 })
 
}
}
